import styled from '@emotion/styled'
import { forwardRef, ReactNode, TextareaHTMLAttributes } from 'react'

import { ErrorText, Label } from './Input'
import { Skeleton } from './Skeleton'

const TextAreaBase = styled.textarea<{ disabled?: boolean }>`
  width: 100%;
  background-color: ${({ theme, disabled }) => (disabled ? theme.onBackgroundLightest : theme.background)};
  border: 1px solid ${({ theme, disabled }) => (!disabled ? theme.onBackgroundLighter : theme.onBackgroundLightest)};
  padding: 0.8rem 0.7rem;

  :focus {
    outline-color: ${({ theme }) => theme.primaryLight};
  }
`

const Subtext = styled.div`
  color: ${({ theme }) => theme.onBackgroundLight};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`

interface TextAreaProps {
  label?: string
  error?: string
  required?: boolean
  skeleton?: boolean
  subtext?: ReactNode
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement> & TextAreaProps>(
  ({ label, error, skeleton, subtext, disabled, ...props }, ref) => {
    return (
      <div>
        {!!label && (
          <Label>
            <Skeleton display="inline-block" active={skeleton}>
              {label}
              {!!props?.required && <span style={{ color: 'crimson', fontSize: '0.9rem' }}> *</span>}
            </Skeleton>
          </Label>
        )}
        <Skeleton display="block" active={skeleton}>
          <TextAreaBase ref={ref} disabled={skeleton || disabled} {...props} />
        </Skeleton>
        {error && <ErrorText error={error} />}
        {subtext && <Subtext>{subtext}</Subtext>}
      </div>
    )
  },
)

TextArea.displayName = 'TextArea'
